export const DEV_URL = 'https://stacks-multisig-api.dev.asigna.io/api/v1/';
// TODO_R: нужно использовать .env для того чтобы переключать эти URL-ы
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const PROD_URL = 'https://stacks-multisig-api.asigna.io/api/v1';
